import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { AuthActions } from './auth.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthEffects {
  sendOtpSuccessEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(AuthActions.submitOtpSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  sendLoginSuccessEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(AuthActions.submitLoginSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
